import { getLocalization } from 'global/global';
import * as React from 'react';
import { Button, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';

interface Props {
  secret: string;
  updateSetting: (value: string) => void;
}

export default function WebhookSecret({ secret, updateSetting}: Props) {
  const [newSecret, setNewSecret] = React.useState('');

  return (
    <div className="settings-div p-2">
      <Form.Label>{getLocalization('webhookSecret')}</Form.Label>
      <pre>
        {secret ? `${secret}`.split('').map(() => '*').join('') : getLocalization('webhookSecretNotSet')}
        <OverlayTrigger
          delay={{ show: 250, hide: 400 }}
          overlay={(
            <Tooltip className="admin-tooltip">
              {getLocalization('webhookSecretDescription')}
            </Tooltip>
          )}
        >
          <Button variant="secondary" className={'float-end'} size="sm">
            <i className="fa fa-info" />
          </Button>
        </OverlayTrigger>
      </pre>
      <Form.Group className="mb-2">
        <Form.Control
          id={'webhook_secret'}
          value={newSecret}
          size="sm"
          onChange={(e) => setNewSecret(e.target.value)}
        />
      </Form.Group>
      <Button
        size="sm"
        onClick={() => updateSetting(newSecret)}
      >
        {getLocalization('updateWebhookSecret')}
      </Button>
    </div>
  );
}
